import four04Component from './404.component';
import four04Route from './404.routes';

angular.module('rym.404', []).component('rym404', four04Component).run(four04Route);
